import { useUser } from '@acme/domains';
import { Sidebar, type NavigationItem } from '@acme/features';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

interface DefaultLayoutProps {
  children: React.ReactNode;
}

export function DefaultLayout({ children }: DefaultLayoutProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, organization, isLoading, logout } = useUser();

  const handleNavigate = (path: string) => {
    navigate(path);
  };

  const adminNavigationItems: NavigationItem[] = [
    {
      label: 'Главная',
      iconName: 'home-outline',
      path: '/dashboard',
    },
    {
      label: 'Пользователи',
      iconName: 'user-circle-outline',
      path: '/users/pending',
    },
    {
      label: 'Заявки',
      iconName: 'clipboard-list-outline',
      path: '/applications',
    },
    {
      label: 'Организации',
      iconName: 'factory',
      path: '/organizations/pending',
    },
    {
      label: 'Обращения',
      iconName: 'file-lines-outline',
      path: '/support/tickets',
    },
    {
      label: 'Чаты',
      iconName: 'message-dots-outline',
      path: '/support/chats',
    },
    // {
    //   label: 'Заявки',
    //   iconName: 'clipboard-list-outline',
    //   path: '/applications',
    //   disabled: true,
    // },
  ];

  return (
    <div className="bg-gray-100 flex h-screen overflow-hidden">
      <Sidebar
        className="h-screen flex-shrink-0"
        navigationItems={adminNavigationItems}
        user={user}
        organization={organization}
        isLoading={isLoading}
        onLogout={logout}
        currentPath={location.pathname}
        onNavigate={handleNavigate}
      />

      <main className="flex-1 overflow-y-auto p-6">{children}</main>
    </div>
  );
}
